import styled from "styled-components";

const BaseLoadingContainerDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;
export const LoadingWrapper = styled(BaseLoadingContainerDiv)`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0000007F;
  z-index: 10;
`;

export default BaseLoadingContainerDiv;
